import Header from "../components/Header";
import FooterDesign from "../components/FooterDesign";
import ProfileImage from "../components/ProfileImage";
import { TextInput } from "./../components/Input/TextInput";
import { useContext } from "react";
import AuthContext from "../contexts/AuthContext";

const Profile = () => {
  const Context = useContext(AuthContext);
  
  const profileEmail = Context.state.user.attributes.email ?? "reachus@konfhub.com";
  const profileName = Context.state.user.attributes.name ?? profileEmail;

  const profileImage = Context.state.user.attributes["custom:profilePicture"];

  return (
    <div
      className="d-flex flex-column justify-content-between sponsor-page"
      style={{ backgroundColor: "#F6F4EF" }}
    >
      <div>
        <div className="top-container" style={{ paddingBottom: "130px" }}>
          <Header backButton={true}>Profile</Header>
        </div>
        <div
          className="d-flex flex-column align-items-center"
          style={{ marginTop: "-76px" }}
        >
          <div className="justify-content-center">
            <ProfileImage profilePic={profileImage}></ProfileImage>
          </div>
          <div className="d-flex flex-column justify-content-center my-3 mx-3 col-10 col-md-6 col-lg-3">
            <label
              htmlFor="profile-name"
              className="parah-text"
              style={{ fontSize: "16px" }}
            >
              Name
            </label>
            <TextInput
              disabled={true}
              id="profile-name"
              value={profileName}
            ></TextInput>
          </div>
          <div className="d-flex flex-column justify-content-center mx-3 col-10 col-md-6 col-lg-3">
            <label
              htmlFor="profile-email"
              className="parah-text"
              style={{ fontSize: "16px" }}
            >
              Email Id
            </label>
            <TextInput
              disabled={true}
              id="profile-email"
              value={profileEmail}
            ></TextInput>
          </div>
        </div>
      </div>
      <FooterDesign></FooterDesign>
      <style>
        {`
                    .input-container{
                        margin-top:2px!important
                    }
                    `}
      </style>
    </div>
  );
};
export default Profile;
